// extracted by mini-css-extract-plugin
module.exports = {"pageContent":"page-content-module--page-content--SFN-W"};